import MyActivePosts from './MyActivePosts';

export default MyActivePosts;
